module.exports = __webpack_public_path__ + "img/page.443b96f1.png";